import { GraduationCap, Heart, Sparkles } from "lucide-react";

export default function About() {
  return (
    <section id="about" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-5 reveal">
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1741522509438-a120c0bb5e88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxjYWxtJTIwaG9saXN0aWMlMjB3ZWxsbmVzcyUyMHRoZXJhcHklMjBtYXNzYWdlfGVufDB8fHx8MTc3ODczOTk4OXww&ixlib=rb-4.1.0&q=85"
                alt="Practitioner at work"
                className="rounded-[36px] w-full h-[520px] object-cover"
              />
              <div className="absolute -right-5 -bottom-5 hidden md:block">
                <div className="bg-secondary/95 text-secondary-foreground rounded-full w-40 h-40 flex flex-col items-center justify-center text-center px-4">
                  <div className="font-serif text-4xl leading-none">12+</div>
                  <div className="text-xs uppercase tracking-widest mt-2 opacity-90">years guiding<br/>healing</div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 reveal">
            <p className="text-xs uppercase tracking-[0.25em] text-secondary mb-4">About the practitioner</p>
            <h2 className="font-serif text-4xl md:text-5xl leading-tight">
              A gentle hand,<br />a steady presence.
            </h2>
            <p className="mt-6 text-lg text-muted-foreground leading-relaxed max-w-2xl">
              I'm <span className="text-foreground italic">Farina Begum</span> — a certified Spinal Flow practitioner
              devoted to helping you reconnect with the wisdom already living in your body. My work blends
              breath, intentional touch, and nervous-system science into sessions that meet you exactly where you are.
            </p>
            <p className="mt-4 text-lg text-muted-foreground leading-relaxed max-w-2xl">
              Every session is held in the calm of your own home — your sanctuary becomes our studio.
            </p>

            <div className="mt-10 grid sm:grid-cols-3 gap-5">
              {[
                { icon: GraduationCap, title: "Certified", text: "Spinal Flow & somatic therapy" },
                { icon: Heart, title: "Compassionate", text: "Trauma-informed, woman-led care" },
                { icon: Sparkles, title: "Holistic", text: "Body, breath, and spirit aligned" },
              ].map((c, i) => (
                <div key={i} className="rounded-2xl border border-border/60 bg-card/60 p-5">
                  <c.icon size={20} className="text-secondary mb-3" />
                  <div className="font-serif text-xl mb-1">{c.title}</div>
                  <p className="text-sm text-muted-foreground">{c.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
